export default __webpack_public_path__ + "static/media/guobastand_puorba.c3aa110d.png";